module.exports = __webpack_public_path__ + "static/35-fc36d45733ee2aad83c79b89a4d3e391.png";